// HTTP headers
export const HEADER_CF_COUNTRY_ID = 'cf-ipcountry'
export const HEADER_IS_BOT = 'is-bot'